"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SliderToolTip = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _styles = require("./styles");

var _react = require("react");

var _customHooks = require("../../../global-files/customHooks");

var _jsxRuntime = require("react/jsx-runtime");

var SliderToolTip = function SliderToolTip(_ref) {
  var infoIcon = _ref.infoIcon,
      slidefront = _ref.slidefront,
      iconSize = _ref.iconSize,
      slidePosition = _ref.slidePosition;

  var _useCloseModal = (0, _customHooks.useCloseModal)("div-slider"),
      _useCloseModal2 = (0, _slicedToArray2.default)(_useCloseModal, 2),
      showMenu = _useCloseModal2[0],
      setShowMenu = _useCloseModal2[1];

  var color = function color(id) {
    for (var i = 1; i <= slidefront.length; i++) {
      if (id === "slidea".concat(i)) {
        document.getElementById("slidea".concat(i)).style.backgroundColor = "#E33AA9";

        if (id === "slidea".concat(slidefront.length)) {
          document.getElementById("button-slide").style.display = "flex";
        }
      } else if (id > "slidea".concat(i)) {
        document.getElementById("slidea".concat(i)).style.backgroundColor = "#FAFAFA";
      } else if (id < "slidea".concat(i)) {
        document.getElementById("slidea".concat(i)).style.backgroundColor = "#C4C4C4";
      }
    }
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
        src: infoIcon,
        alt: "info icon",
        className: iconSize,
        onClick: function onClick(e) {
          e.stopPropagation();
          e.preventDefault();
          setShowMenu(true);
        }
      }), showMenu && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Slider, {
        id: "div-slider",
        className: slidePosition,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("ul", {
          className: "slider",
          children: slidefront.map(function (item, index) {
            return /*#__PURE__*/(0, _jsxRuntime.jsxs)("li", {
              id: "slide".concat(index + 1),
              className: "slide".concat(index + 1) === "slide".concat(slidefront.length) ? "end-div" : "",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                  src: item.slide
                })
              }), "slide".concat(index + 1) === "slide".concat(slidefront.length) ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
                children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  className: "lema-end",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                    children: item.title
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                    children: item.description
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
                  id: "button-slide",
                  onClick: function onClick(e) {
                    setShowMenu(false);
                  },
                  children: "Cerrar"
                })]
              }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
                children: [item.title !== undefined ? /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                  children: item.title
                }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                  children: item.description
                })]
              })]
            });
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("ul", {
          className: "menu",
          children: slidefront.map(function (item, index) {
            return /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
                id: "slidea".concat(index + 1),
                onClick: function onClick(e) {
                  color("slidea".concat(index + 1));

                  for (var i = 1; i <= slidefront.length; i++) {
                    if (index + 1 === i) {
                      document.getElementById("slide".concat(index + 1)).style.opacity = 1;
                    } else if (index + 1 > i || index + 1 < i) {
                      document.getElementById("slide".concat(i)).style.opacity = 0;
                    }
                  }
                }
              })
            });
          })
        })]
      })]
    })
  });
};

exports.SliderToolTip = SliderToolTip;